import axios from "axios";
import {message} from "antd";
import {getPool, IdentityPoolId, POOL_KEY} from "./getCognitoData";
import * as AWS from "aws-sdk/global";
import {SET_TOKEN_EXPIRE} from "../redux-store/reducers/loginReducer/loginReducer";

export function cleanPayload(obj, includeEmptyQuotes = false) {
    return JSON.parse(JSON.stringify(obj, (key, value) => {
        const isNull = includeEmptyQuotes ? (value === null || value === "") : (value === null);
        return isNull ? undefined : value
    }));
}

export function payloadNullToQuotes(obj) {
    return JSON.parse(JSON.stringify(obj).replaceAll('null', "\"\""));
}

export function getApiUrl(object_name) {
    if (object_name === 'orders' || object_name === 'shipping_base_addresses') {
        return process.env.OM_ENDPOINT;
    } else if (object_name === 'sites') {
        return process.env.SITES_ENDPOINT;
    }
    return process.env.PIM_ENDPOINT;
}

export const getAvailableAmountForRefund = (order) => {
    const refundedOrderItemsSum = order?.refund_orders?.length > 0 ? order?.refund_orders?.reduce((prev, refund_order) => prev + refund_order.amount, 0) : 0;
    return order?.total - refundedOrderItemsSum;
}

export const getRefundedAmountAlready = (order) => {
    return order?.refund_orders?.length > 0 ? order?.refund_orders?.reduce((prev, refund_order) => prev + refund_order.amount, 0) : 0
}

export const getBase64Image = (file) => {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

export const getFilteredState = (actionPayload, prevValues) => {
    let payload = [];
    if (actionPayload) {
        payload = [...prevValues, actionPayload];

        if (prevValues.length > 0) {
            const filteredValues = prevValues.filter(val => val.id !== actionPayload.id)
            payload = [...filteredValues, actionPayload]
        }

    }

    return payload;
}

export const getCleanPayload = (state, payload) => {
    if (payload.length === 0) return [];
    const filteredState = state.filter(val => !payload.map(val => {
        return val.id;
    }).includes(val.id));
    return [...filteredState, ...payload];
}

export const renderTitleFromType = (type,
                                    isMoreThanOne = false,
                                    isFirstLetterUppercase = false) => {
    const translations = {
        'products': isMoreThanOne ? 'produkter' : 'produkt',
        'attributes': isMoreThanOne ? 'attribut' : 'attribut',
        'categories': isMoreThanOne ? 'kategori' : 'kategori',
        'shipping-base-addresses': isMoreThanOne ? 'avsändaradresser' : 'avsändarensadress',
        'shipping-methods': isMoreThanOne ? 'fraktmetoder' : 'frakt metod',
        'shipping-classes': isMoreThanOne ? 'fraktklasser' : 'fraktklass',
        'stock_objects': isMoreThanOne ? 'lagerobjekt' : 'lagerobjekt',
        'back_instock_objects': isMoreThanOne ? 'backInstockObject' : 'backInstockObject',
        'orders': isMoreThanOne ? 'ordrar': 'order',
        'upsell-objects': isMoreThanOne ? 'tilläggsköp' : 'tilläggsköp',
        'sites': isMoreThanOne ? 'försäljningsställen' : 'försäljningsställen',
        'pick-lists': isMoreThanOne ? 'plocklista' : 'plocklista',
        'warehouses': isMoreThanOne ? 'lagerställen' : '',
        'tags': isMoreThanOne ? 'taggar' : 'tagger',
        'images': isMoreThanOne ? 'bilder' : 'bilde'
    }

    if (type == 'upsell-objects') {
        type = 'Tilläggsköp'
    }

    if (!translations.hasOwnProperty(type)) {
        return '';
    }

    return isFirstLetterUppercase ?
        (translations[type].charAt(0).toUpperCase() + translations[type].slice(1)) :
        translations[type];
}

export const getParamsFromObject = (params) => {
    const paramsObject = {};
    if (params && Object.keys(params).length > 0) {
        Object.keys(params).forEach(param => {
            if (!Array.isArray(params[param]) && typeof params[param] === 'object' && params[param] !== null) {
                Object.keys(params[param]).map((key, ind) => {
                    if (params[param][key]) {
                        let reworkedKey = param === 'order_total' ? 'order_total_' + key : (param === 'order_number' ? 'order_number_' + key : key)
                        paramsObject[reworkedKey] = params[param][key]
                    }
                })
            }

            if (Array.isArray(params[param]) && params[param].length > 0) {
                if (!Array.isArray(params[param][0]) && params[param][0] !== null && typeof params[param][0] === 'object') {
                    Object.keys(params[param][0]).map((key, ind) => {
                        if (params[param][0][key]) {
                            paramsObject[key] = params[param][0][key]
                        }
                    })
                } else {
                    paramsObject[param] = params[param].map(item => item).join(',')
                }
            }

            if (typeof params[param] !== 'object' && params[param]) {
                paramsObject[param] = params[param]
            }
        })
    }

    return paramsObject;
}

export const getParams = (params = {}) => {
    if (Object.keys(params).length === 0) return ''
    return Object.keys(params).map((param, index) => (index === 0 ? '?' : '') + param + "=" + params[param]).join('&');
}

export const customFetch = ({
                                url, method, token, values = {}, multipart = {}, successCallback = () => {
    }, setLoading = () => {
    }
                            }) => {
    return axios({
        method,
        url, ...{...((values instanceof FormData || typeof values === 'object') && method !== 'delete' && {data: values})},
        headers: {'Authorization': token, ...multipart}
    })
        .then(res => {
            successCallback(res)
        })
        .catch(errors => {
            message.error(errors.response?.data?.detail ?? (errors.response?.data?.message ?? errors.toString()));
            setLoading()
        });
}

export const renderDateYMD = (date) => {
    const months = ((date.getMonth() + 1) > 9 ? '' : '0') + (date.getMonth() + 1),
        days = (date.getDate() > 9 ? '' : '0') + date.getDate();
    return `${date.getFullYear()}-${months}-${days}`;
}

export const refreshSession = (dispatch) => {
    const user = getPool().getCurrentUser();
    if (user) {
        user.getSession(function (err, session) {
            if (!err) {
                user.refreshSession(session.getRefreshToken(), (err, session) => {
                    if (err) {
                        console.log(err);
                    } else {
                        if (!AWS.config.credentials) {
                            AWS.config.credentials = new AWS.CognitoIdentityCredentials({
                                IdentityPoolId,
                                Logins: {[POOL_KEY]: session.getIdToken().getJwtToken()},
                            });
                        } else {
                            AWS.config.credentials.params.Logins[POOL_KEY] = session.getIdToken().getJwtToken();
                        }

                        AWS.config.credentials.refresh(err => {
                            if (err) {
                                console.error('Token refresh error >>> ', err);
                            } else {
                                localStorage.setItem('token', session.getIdToken().getJwtToken())
                                localStorage.setItem('tokenExpire', session.getIdToken().getExpiration().toString())
                                dispatch({
                                    type: SET_TOKEN_EXPIRE,
                                    payload: session.getIdToken().getExpiration().toString()
                                })
                                console.log('token updated successfully!')
                            }
                        });
                    }
                });
            }
        });
    }

}

export const getCountryByCode = ({code}) => {
    const foundCode = Object.keys(countriesWithCode).find(key => key === code);
    return countriesWithCode[foundCode]
}

export const insert = (arr, index, newItem) => [
    ...arr.slice(0, index),
    newItem,
    ...arr.slice(index)
]


export const countriesWithCode = {
    "AF": "Afghanistan",
    "AL": "Albania",
    "DZ": "Algeria",
    "AS": "American Samoa",
    "AD": "Andorra",
    "AO": "Angola",
    "AI": "Anguilla",
    "AQ": "Antarctica",
    "AG": "Antigua and Barbuda",
    "AR": "Argentina",
    "AM": "Armenia",
    "AW": "Aruba",
    "AU": "Australia",
    "AT": "Austria",
    "AZ": "Azerbaijan",
    "BS": "Bahamas (the)",
    "BH": "Bahrain",
    "BD": "Bangladesh",
    "BB": "Barbados",
    "BY": "Belarus",
    "BE": "Belgium",
    "BZ": "Belize",
    "BJ": "Benin",
    "BM": "Bermuda",
    "BT": "Bhutan",
    "BO": "Bolivia (Plurinational State of)",
    "BQ": "Bonaire, Sint Eustatius and Saba",
    "BA": "Bosnia and Herzegovina",
    "BW": "Botswana",
    "BV": "Bouvet Island",
    "BR": "Brazil",
    "IO": "British Indian Ocean Territory (the)",
    "BN": "Brunei Darussalam",
    "BG": "Bulgaria",
    "BF": "Burkina Faso",
    "BI": "Burundi",
    "CV": "Cabo Verde",
    "KH": "Cambodia",
    "CM": "Cameroon",
    "CA": "Canada",
    "KY": "Cayman Islands (the)",
    "CF": "Central African Republic (the)",
    "TD": "Chad",
    "CL": "Chile",
    "CN": "China",
    "CX": "Christmas Island",
    "CC": "Cocos (Keeling) Islands (the)",
    "CO": "Colombia",
    "KM": "Comoros (the)",
    "CD": "Congo (the Democratic Republic of the)",
    "CG": "Congo (the)",
    "CK": "Cook Islands (the)",
    "CR": "Costa Rica",
    "HR": "Croatia",
    "CU": "Cuba",
    "CW": "Curaçao",
    "CY": "Cyprus",
    "CZ": "Czechia",
    "CI": "Côte d'Ivoire",
    "DK": "Denmark",
    "DJ": "Djibouti",
    "DM": "Dominica",
    "DO": "Dominican Republic (the)",
    "EC": "Ecuador",
    "EG": "Egypt",
    "SV": "El Salvador",
    "GQ": "Equatorial Guinea",
    "ER": "Eritrea",
    "EE": "Estonia",
    "SZ": "Eswatini",
    "ET": "Ethiopia",
    "FK": "Falkland Islands (the) [Malvinas]",
    "FO": "Faroe Islands (the)",
    "FJ": "Fiji",
    "FI": "Finland",
    "FR": "France",
    "GF": "French Guiana",
    "PF": "French Polynesia",
    "TF": "French Southern Territories (the)",
    "GA": "Gabon",
    "GM": "Gambia (the)",
    "GE": "Georgia",
    "DE": "Germany",
    "GH": "Ghana",
    "GI": "Gibraltar",
    "GR": "Greece",
    "GL": "Greenland",
    "GD": "Grenada",
    "GP": "Guadeloupe",
    "GU": "Guam",
    "GT": "Guatemala",
    "GG": "Guernsey",
    "GN": "Guinea",
    "GW": "Guinea-Bissau",
    "GY": "Guyana",
    "HT": "Haiti",
    "HM": "Heard Island and McDonald Islands",
    "VA": "Holy See (the)",
    "HN": "Honduras",
    "HK": "Hong Kong",
    "HU": "Hungary",
    "IS": "Iceland",
    "IN": "India",
    "ID": "Indonesia",
    "IR": "Iran (Islamic Republic of)",
    "IQ": "Iraq",
    "IE": "Ireland",
    "IM": "Isle of Man",
    "IL": "Israel",
    "IT": "Italy",
    "JM": "Jamaica",
    "JP": "Japan",
    "JE": "Jersey",
    "JO": "Jordan",
    "KZ": "Kazakhstan",
    "KE": "Kenya",
    "KI": "Kiribati",
    "KP": "Korea (the Democratic People's Republic of)",
    "KR": "Korea (the Republic of)",
    "KW": "Kuwait",
    "KG": "Kyrgyzstan",
    "LA": "Lao People's Democratic Republic (the)",
    "LV": "Latvia",
    "LB": "Lebanon",
    "LS": "Lesotho",
    "LR": "Liberia",
    "LY": "Libya",
    "LI": "Liechtenstein",
    "LT": "Lithuania",
    "LU": "Luxembourg",
    "MO": "Macao",
    "MG": "Madagascar",
    "MW": "Malawi",
    "MY": "Malaysia",
    "MV": "Maldives",
    "ML": "Mali",
    "MT": "Malta",
    "MH": "Marshall Islands (the)",
    "MQ": "Martinique",
    "MR": "Mauritania",
    "MU": "Mauritius",
    "YT": "Mayotte",
    "MX": "Mexico",
    "FM": "Micronesia (Federated States of)",
    "MD": "Moldova (the Republic of)",
    "MC": "Monaco",
    "MN": "Mongolia",
    "ME": "Montenegro",
    "MS": "Montserrat",
    "MA": "Morocco",
    "MZ": "Mozambique",
    "MM": "Myanmar",
    "NA": "Namibia",
    "NR": "Nauru",
    "NP": "Nepal",
    "NL": "Netherlands (the)",
    "NC": "New Caledonia",
    "NZ": "New Zealand",
    "NI": "Nicaragua",
    "NE": "Niger (the)",
    "NG": "Nigeria",
    "NU": "Niue",
    "NF": "Norfolk Island",
    "MP": "Northern Mariana Islands (the)",
    "NO": "Norway",
    "OM": "Oman",
    "PK": "Pakistan",
    "PW": "Palau",
    "PS": "Palestine, State of",
    "PA": "Panama",
    "PG": "Papua New Guinea",
    "PY": "Paraguay",
    "PE": "Peru",
    "PH": "Philippines (the)",
    "PN": "Pitcairn",
    "PL": "Poland",
    "PT": "Portugal",
    "PR": "Puerto Rico",
    "QA": "Qatar",
    "MK": "Republic of North Macedonia",
    "RO": "Romania",
    "RU": "Russian Federation (the)",
    "RW": "Rwanda",
    "RE": "Réunion",
    "BL": "Saint Barthélemy",
    "SH": "Saint Helena, Ascension and Tristan da Cunha",
    "KN": "Saint Kitts and Nevis",
    "LC": "Saint Lucia",
    "MF": "Saint Martin (French part)",
    "PM": "Saint Pierre and Miquelon",
    "VC": "Saint Vincent and the Grenadines",
    "WS": "Samoa",
    "SM": "San Marino",
    "ST": "Sao Tome and Principe",
    "SA": "Saudi Arabia",
    "SN": "Senegal",
    "RS": "Serbia",
    "SC": "Seychelles",
    "SL": "Sierra Leone",
    "SG": "Singapore",
    "SX": "Sint Maarten (Dutch part)",
    "SK": "Slovakia",
    "SI": "Slovenia",
    "SB": "Solomon Islands",
    "SO": "Somalia",
    "ZA": "South Africa",
    "GS": "South Georgia and the South Sandwich Islands",
    "SS": "South Sudan",
    "ES": "Spain",
    "LK": "Sri Lanka",
    "SD": "Sudan (the)",
    "SR": "Suriname",
    "SJ": "Svalbard and Jan Mayen",
    "SE": "Sweden",
    "CH": "Switzerland",
    "SY": "Syrian Arab Republic",
    "TW": "Taiwan",
    "TJ": "Tajikistan",
    "TZ": "Tanzania, United Republic of",
    "TH": "Thailand",
    "TL": "Timor-Leste",
    "TG": "Togo",
    "TK": "Tokelau",
    "TO": "Tonga",
    "TT": "Trinidad and Tobago",
    "TN": "Tunisia",
    "TR": "Turkey",
    "TM": "Turkmenistan",
    "TC": "Turks and Caicos Islands (the)",
    "TV": "Tuvalu",
    "UG": "Uganda",
    "UA": "Ukraine",
    "AE": "United Arab Emirates (the)",
    "GB": "United Kingdom of Great Britain and Northern Ireland (the)",
    "UM": "United States Minor Outlying Islands (the)",
    "US": "United States of America (the)",
    "UY": "Uruguay",
    "UZ": "Uzbekistan",
    "VU": "Vanuatu",
    "VE": "Venezuela (Bolivarian Republic of)",
    "VN": "Viet Nam",
    "VG": "Virgin Islands (British)",
    "VI": "Virgin Islands (U.S.)",
    "WF": "Wallis and Futuna",
    "EH": "Western Sahara",
    "YE": "Yemen",
    "ZM": "Zambia",
    "ZW": "Zimbabwe",
    "AX": "Åland Islands"
};

export const getTextFromType = ({
                                    string,
                                    isRemoveSymbols = true,
                                    isRemoveSymbolsAndUppercase = false,
                                    isRemoveLastAndAllToUppercase = false
                                }) => {
    if (isRemoveSymbols) {
        if (/tes$/g.test(string)) {
            return string.replace(/tes$/g, 'te').replaceAll('_', ' ').replaceAll('-', ' ')
        } else if (/ies$/g.test(string)) {
            return string.replace(/ies$/g, 'y').replaceAll('_', ' ').replaceAll('-', ' ')
        } else {
            return string.replace(/es$|s$/g, '').replaceAll('_', ' ').replaceAll('-', ' ')
        }
    }

    if (isRemoveSymbolsAndUppercase) {
        const splitString = string.includes('-') ? string.split('-') : (string.includes('_') ? string.split('_') : null)
        if (splitString) {
            return splitString.map((item, index) => index === 0 ? item : item.charAt(0).toUpperCase() + item.slice(1)).reduce((prev, item) => prev + item, '')
        }
        return string;
    }

    if (isRemoveLastAndAllToUppercase) {
        if (/ies$/g.test(string)) {
            return string.replace(/ies$/g, 'y').toUpperCase();
        } else if (/tes$/g.test(string)) {
            return string.replace(/tes$/g, 'te').toUpperCase();
        } else if (/ges$/g.test(string)) {
            return string.replace(/ges$/g, 'ge').toUpperCase();
        } else {
            return string.replace(/es$|s$/g, '').toUpperCase();
        }
    }

    return string.replace(/es$|s$/g, '');
}

export const getFallbackImage = () => {
    return 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMIAAADDCAYAAADQvc6UAAABRWlDQ1BJQ0MgUHJvZmlsZQAAKJFjYGASSSwoyGFhYGDIzSspCnJ3UoiIjFJgf8LAwSDCIMogwMCcmFxc4BgQ4ANUwgCjUcG3awyMIPqyLsis7PPOq3QdDFcvjV3jOD1boQVTPQrgSkktTgbSf4A4LbmgqISBgTEFyFYuLykAsTuAbJEioKOA7DkgdjqEvQHEToKwj4DVhAQ5A9k3gGyB5IxEoBmML4BsnSQk8XQkNtReEOBxcfXxUQg1Mjc0dyHgXNJBSWpFCYh2zi+oLMpMzyhRcASGUqqCZ16yno6CkYGRAQMDKMwhqj/fAIcloxgHQqxAjIHBEugw5sUIsSQpBobtQPdLciLEVJYzMPBHMDBsayhILEqEO4DxG0txmrERhM29nYGBddr//5/DGRjYNRkY/l7////39v///y4Dmn+LgeHANwDrkl1AuO+pmgAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAwqADAAQAAAABAAAAwwAAAAD9b/HnAAAHlklEQVR4Ae3dP3PTWBSGcbGzM6GCKqlIBRV0dHRJFarQ0eUT8LH4BnRU0NHR0UEFVdIlFRV7TzRksomPY8uykTk/zewQfKw/9znv4yvJynLv4uLiV2dBoDiBf4qP3/ARuCRABEFAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghggQAQZQKAnYEaQBAQaASKIAQJEkAEEegJmBElAoBEgghgg0Aj8i0JO4OzsrPv69Wv+hi2qPHr0qNvf39+iI97soRIh4f3z58/u7du3SXX7Xt7Z2enevHmzfQe+oSN2apSAPj09TSrb+XKI/f379+08+A0cNRE2ANkupk+ACNPvkSPcAAEibACyXUyfABGm3yNHuAECRNgAZLuYPgEirKlHu7u7XdyytGwHAd8jjNyng4OD7vnz51dbPT8/7z58+NB9+/bt6jU/TI+AGWHEnrx48eJ/EsSmHzx40L18+fLyzxF3ZVMjEyDCiEDjMYZZS5wiPXnyZFbJaxMhQIQRGzHvWR7XCyOCXsOmiDAi1HmPMMQjDpbpEiDCiL358eNHurW/5SnWdIBbXiDCiA38/Pnzrce2YyZ4//59F3ePLNMl4PbpiL2J0L979+7yDtHDhw8vtzzvdGnEXdvUigSIsCLAWavHp/+qM0BcXMd/q25n1vF57TYBp0a3mUzilePj4+7k5KSLb6gt6ydAhPUzXnoPR0dHl79WGTNCfBnn1uvSCJdegQhLI1vvCk+fPu2ePXt2tZOYEV6/fn31dz+shwAR1sP1cqvLntbEN9MxA9xcYjsxS1jWR4AIa2Ibzx0tc44fYX/16lV6NDFLXH+YL32jwiACRBiEbf5KcXoTIsQSpzXx4N28Ja4BQoK7rgXiydbHjx/P25TaQAJEGAguWy0+2Q8PD6/Ki4R8EVl+bzBOnZY95fq9rj9zAkTI2SxdidBHqG9+skdw43borCXO/ZcJdraPWdv22uIEiLA4q7nvvCug8WTqzQveOH26fodo7g6uFe/a17W3+nFBAkRYENRdb1vkkz1CH9cPsVy/jrhr27PqMYvENYNlHAIesRiBYwRy0V+8iXP8+/fvX11Mr7L7ECueb/r48eMqm7FuI2BGWDEG8cm+7G3NEOfmdcTQw4h9/55lhm7DekRYKQPZF2ArbXTAyu4kDYB2YxUzwg0gi/41ztHnfQG26HbGel/crVrm7tNY+/1btkOEAZ2M05r4FB7r9GbAIdxaZYrHdOsgJ/wCEQY0J74TmOKnbxxT9n3FgGGWWsVdowHtjt9Nnvf7yQM2aZU/TIAIAxrw6dOnAWtZZcoEnBpNuTuObWMEiLAx1HY0ZQJEmHJ3HNvGCBBhY6jtaMoEiJB0Z29vL6ls58vxPcO8/zfrdo5qvKO+d3Fx8Wu8zf1dW4p/cPzLly/dtv9Ts/EbcvGAHhHyfBIhZ6NSiIBTo0LNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiECRCjUbEPNCRAhZ6NSiAARCjXbUHMCRMjZqBQiQIRCzTbUnAARcjYqhQgQoVCzDTUnQIScjUohAkQo1GxDzQkQIWejUogAEQo121BzAkTI2agUIkCEQs021JwAEXI2KoUIEKFQsw01J0CEnI1KIQJEKNRsQ80JECFno1KIABEKNdtQcwJEyNmoFCJAhELNNtScABFyNiqFCBChULMNNSdAhJyNSiEC/wGgKKC4YMA4TAAAAABJRU5ErkJggg==';
}

export const firstLetterToUppercase = (string = '') => {
    return string.charAt(0).toUpperCase() + string.slice(1)
}
